import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {newsletterSegmentView_template} from "../components/templates/newsletterSegmentView_template";

declare var page: any;

export class newsletter_segment_view extends vnModule_knockoutJS {
    protected segmentView: newsletterSegmentView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.segmentView = new newsletterSegmentView_template("newsletterSegmentView", this.viewModel, this);
        return [this.segmentView.build()];
    }

    protected getModuleName(): string {
        return "newsletter_segment_view";
    }

    fillPage(): void {
        this.getReferences();
    }

    protected getReferences(): void {
        this.loadingIn(this.segmentView.builtTemplate);
        let url = '/api/brand/' + this.getBrandId() + '/newsletter/segments/references/';
        this.XHRHdl = new XMLHttpRequestHandler(url, [], this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesReturn;
        this.XHRHdl.execute();
    }

    protected onReferencesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.segmentView.setReferences(responseParsed);
                obj.segmentView.setReadOnly(true);
                obj.getSegment();
            });
            obj.loadingOut(obj.segmentView.builtTemplate);
        };
    }

    protected getSegment(): void {
        let id = this.getVnAppZone().app.params.id;
        let url = '/api/brand/' + this.getBrandId() + '/newsletter/segments/get/' + id + '/';
        this.XHRHdl = new XMLHttpRequestHandler(url, [], this);
        this.XHRHdl.onReadyStateFunction = this.onSegmentReturn;
        this.XHRHdl.execute();
    }

    protected onSegmentReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.segmentView.setSegment(responseParsed.segment);
            });
        };
    }

    public loadProfileOptions(field: string, callback: Function): void {
        let url = '/api/brand/' + this.getBrandId() + '/newsletter/segments/autocomplete/?field=' + encodeURIComponent(field);
        let XHRHdl = new XMLHttpRequestHandler(url, [], this);
        XHRHdl.onReadyStateFunction = (req, obj) => () => {
            obj.manageResponse(req, obj, () => callback(JSON.parse(req.request.response).data || []));
        };
        XHRHdl.execute();
    }

    public cancelForm(): void {
        page.redirect('/brand/' + this.getBrandId() + '/newsletter/segments/');
    }

    public edit(): void {
        page.redirect('/brand/' + this.getBrandId() + '/newsletter/segments/edit/' + this.getVnAppZone().app.params.id + '/');
    }

    public getBrandId(): string {
        return this.getVnAppZone().app.params.idBrand;
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_segment_view.ts